export enum DHLFacilityType {
    DHL = 'dhl-aviation',
}
